import React, { lazy, Suspense } from 'react'
import { SliderBasicItemLoading } from './SliderBasicItemMovieLazy'

const SliderBasicItemAd = lazy(() => import('./SliderBasicItemAd'))


const SliderBasicItemAdLazy = (props) => (
    <Suspense fallback={<SliderBasicItemLoading 
        className={props.className + ' own-content'} 
        title={props.adData.title} 
        hasScrollLink={false}
        isArthouse={props.theme === 'Arthouse'}
    />}>
        <SliderBasicItemAd
            {...props}
        />
    </Suspense>
)

export default SliderBasicItemAdLazy